import React from "react";
import { statusBadgeColor } from "../utils/vaptConstants";

// Display-only status label: highlighted text color, no background/border/
// pill container, never clickable — used consistently across every VAPT
// screen (Scan Manager, Scan Details, Projects, Findings, Validation, Risk,
// Remediation, Retest, Reports).
const VaptStatusBadge = ({ status, size = "md" }) => {
  const sizeCls = size === "sm" ? "text-[11px]" : "text-xs";
  return <span className={`font-semibold whitespace-nowrap ${sizeCls} ${statusBadgeColor(status)}`}>{status || "Unknown"}</span>;
};

export default VaptStatusBadge;
